module.exports = __webpack_public_path__ + "static/img/穿防护服.0cbc52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/穿防护服.png
// module id = TZMx
// module chunks = 1